module.exports = __webpack_public_path__ + "static/media/satelite.035226f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/satelite.png
// module id = 628
// module chunks = 0